var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolationsmodus",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 41.65 47.87",
    style: {
      enableBackground: "new 0 0 41.65 47.87"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D19856;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.22,12.49c0-4.38,0.97-8.62,2.83-12.49C6.09,3.88-0.02,12.85-0.02,22.91c0,13.76,11.2,24.96,24.97,24.96 c6.19,0,12.15-2.34,16.7-6.43c-0.16,0-0.32,0.01-0.47,0.01C25.21,41.45,12.22,28.46,12.22,12.49z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/late.8966ad813d5ed1030fd19a4ff69ef14e.svg";